<div class="hx-section__header">
  @if (dragHandleEnabled()) {
    <button
      class="hx-section__drag-handle"
      type="button"
      cdkDragHandle
      aria-label="Drag to reorder section"
      title="Drag to reorder">
      <hx-icon svgIcon="ccs-grip-dots-vertical" />
    </button>
  }

  @if (showChevron() && hasSubSections()) {
    <button
      hxIconButton
      variant="ghost"
      context="brand"
      size="xs"
      [fontIcon]="toggleIcon()"
      class="hx-section__toggle-chevron"
      title="Toggle subsections"
      [attr.aria-label]="toggleLabel()"
      [hxTooltip]="toggleLabel()"
      [attr.aria-pressed]="isExpandedAll()"
      (click)="handleToggleAll()"></button>
  }

  <div class="hx-section__title" [attr.aria-label]="title()" [title]="title()">
    <span class="hx-section__title-main">
      @if (titleIcon()) {
        <hx-icon class="hx-section__heading-icon" [svgIcon]="titleIcon()!" />
      }
      <span class="hx-section__title-text">{{ title() }}</span>
      @if (tooltip()) {
        <hx-icon
          fontIcon="info-circle"
          [inline]="true"
          class="hx-section__tooltip-icon"
          [hxTooltip]="tooltip()!"></hx-icon>
      }
    </span>
    @if (subTitle()) {
      <span class="hx-section__breadcrumb-separator">&gt;</span>
      <span class="hx-section__subtitle">
        @if (subTitleIcon()) {
          <hx-icon class="hx-section__heading-icon" [svgIcon]="subTitleIcon()!" />
        }
        <span class="hx-section__subtitle-text">{{ subTitle() }}</span>
        @if (subTitleStatusPresentation(); as statusPresentation) {
          <span class="hx-section__subtitle-status" [attr.data-status]="subTitleStatus()">
            <hx-icon class="hx-section__subtitle-status-icon" [inline]="true" [svgIcon]="statusPresentation.icon" />
            <span class="hx-section__subtitle-status-label">{{ statusPresentation.label }}</span>
          </span>
        }
      </span>
    }
    <ng-content select="[hxSectionAction]" />
    <ng-content select="[hxSectionNavigation]" />
  </div>

  @if (showToggleIcon() && hasSubSections()) {
    <span class="hx-section__toggle-label">{{ toggleLabel() }}</span>
    <button
      class="hx-section__toggle"
      type="button"
      title="Toggle subsections"
      [attr.aria-label]="toggleLabel()"
      [attr.aria-pressed]="isExpandedAll()"
      (click)="handleToggleAll()">
      <hx-icon class="hx-section__toggle-icon" [svgIcon]="toggleArrowIcon()" />
    </button>
  }
</div>

<div class="hx-section__content">
  <ng-content />
  <!-- Content scrolls inside this region when overflow occurs -->
  <div aria-hidden="true" class="hx-section__spacer"></div>
</div>
